import React from 'react';
import './Home.css';
function Goals() {
  return (
    <section id="goals">
    <h2>Goals</h2>
    <p>
    &nbsp; I am eager to start my professional career and contribute to meaningful projects that make a difference. My goal is to join a forward-thinking organization where I can learn, grow, and apply my skills to solve real-world problems.
    </p>
    </section>
  );
}

export default Goals;
